<div class="style">
  @if (showHeader) {
    <h1 class="large mb-4 text-center">{{ 'landing.style.title' | translate }}</h1>
    <p class="mb-4 text-center">{{ 'landing.style.subtitle' | translate }}</p>
  }

  <div class="style-wrapper">
    <app-style-picker class="flex-1" selectionMode="both" (selectedStyleChange)="onStyleSelected($event)"></app-style-picker>
    <div class="style-image">
      <div class="style-image-frame">
        <img [src]="selectedStyle()?.preview?.full || selectedStyle()?.preview?.preview || selectedStyle()?.media?.full || defaultPreviewImage" [alt]="selectedStyle()?.name || 'Style preview'" />
        <div class="style-image-pill-container">
          <div class="style-image-pill">
            {{ 'landing.style.tap_to_preview' | translate }}
          </div>
        </div>
        <div class="style-image-upload-anchor">
          <div class="style-image-upload-desktop style-image-upload style-image-upload-short">
            <img src="/assets/imgs/loader.png" alt="Upload icon" />
            <div class="line-height-2"><span>{{ 'landing.style.upload_cta' | translate }}</span> {{ 'landing.style.upload_text' | translate }}</div>
            <div class="style-image-upload-button">
              <app-button (click)="fileInput.click()" size="m-small" [label]="'landing.style.upload_photo' | translate" customIconSrc="/assets/icons/picture.svg" [shadow]="true" [fullWidth]="true"></app-button>
            </div>
            <div>{{ 'landing.style.upload_format' | translate }}</div>
          </div>
        </div>
      </div>
      <input #fileInput (change)="fileChangeEvent($event)" accept="image/*" style="display:none" type="file"/>
    </div>
  </div>
  <div class="style-mobile-cta">
    <app-button (click)="fileInput.click()" [label]="'landing.style.upload_photo' | translate" customIconSrc="/assets/icons/picture.svg" [shadow]="false" [fullWidth]="true"></app-button>
  </div>
</div>
